<template>
    <div class="form-no-result" :class="getSceneStyle" @click="onClick">
        <div class="btn">
            {{ text }}
        </div>
    </div>
</template>
<script>

export default {
    props: {
        text: {
            type: String,
            default: '没有我想选择的内容',
        },
        sceneType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            getSceneStyle: 'scene-' + this.sceneType,
        };
    },
    methods: {
        onClick() {
            this.$emit('on-no-result-click');
        },
    },
};
</script>
<style lang="less" scoped>
.form-no-result {
    // background: var(--bg-common, #f8f8f8);
    color: var(--font-common, #222);
    width: 100%;
    border-top: 0.5px var(--border-evaluate, #eaeaea) solid;
    padding: 12px 19px;
    padding-bottom: 30px;
    box-sizing: border-box;
    .btn {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        border-radius: 20px;
        border: 1px solid var(--border-evaluate, #eaeaea);
    }
}
.scene-bank {
    // background-color: var(--bg-dialog, #fff);
}
</style>
